<template>
<div>
    <img class="w-full object-cover object-center h-[60vh] sm:h-[70vh] md:h-[80vh] lg:h-[740px]" src="../assets/photos/lauren_ray_table_name_V2.JPG" alt="Table Name"/>
    <TaglineMessage id="services"/>
    <HowItWorks id="process"/>
    <TestimonialSection id="testimonials"/>
    <AboutSection id="about"/>
    <SocialGallery id="gallery"/>
    <ContactUs id="contact"/>
    </div>
</template>


<script>
import AboutSection from '../components/AboutSection.vue';
import SocialGallery from '../components/SocialGallery.vue';
import TaglineMessage from '../components/TaglineMessage.vue';
import ContactUs from '../components/ContactUs.vue'
import TestimonialSection from '../components/TestimonialSection.vue';
import HowItWorks from '../components/HowItWorks.vue';

export default {
  name: 'HomePage', 
  components: {
    TaglineMessage,
    AboutSection,
    SocialGallery,
    ContactUs,
    TestimonialSection,
    HowItWorks
  }
};
</script>

<style scoped>
</style>